import React from 'react';
import { Navigate } from "react-router-dom";

const AuthProtected = (props: any) => {
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  if (isLoggedIn !== "true") {
    return <Navigate to="/login" replace />;
  }
  return <>{props.children}</>;
};

export { AuthProtected };